export default "__VITE_ASSET__mwFIyUp7__"